import React, { Component } from 'react'
import CompareScreen from './CompareScreen.jsx'
import { bindActionCreators, compose } from 'redux'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { isMobile } from 'react-device-detect'

import { geSpecifictUserFeed, getUserData } from '../../Api/backendApi'

import { scrollFixer } from '../theme/mixins'

class CompareScreenContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      rows: 1,
      dataLength: props.dataLength,
      openMenu: false,
      isPlayerActive: false,
      currentEntryId: this.props.match.params.currentId,
      earliestEntryId: this.props.match.params.earliestId,
      currentFeed: {},
      earliestFeed: {},
      currentSideImage: null,
      currentBackImage: null,
      currentFrontImage: null,
      earliestSideImage: null,
      earliestBackImage: null,
      earliestFrontImage: null,
      user: {},
    }
  }

  componentDidMount = async () => {
    const scrollContainer = document.querySelector('.scroll-container')
    if (!isMobile) {
      const scrolledWidth = `${
        (window.innerWidth / 5) * 2 - window.innerWidth / scrollFixer()
      }`
      scrollContainer.scrollTo(`${scrolledWidth}`, 0)
    } else {
      scrollContainer.scrollTo(window.innerWidth * 0.76, 0)
    }
    await this.getFeeds()
    await this.setPhotosInState()
    await this.getUser()
  }

  getFeeds = async () => {
    const currentFeed = await geSpecifictUserFeed(this.state.currentEntryId)
    const earliestFeed = await geSpecifictUserFeed(this.state.earliestEntryId)

    this.setState({
      currentFeed,
      earliestFeed,
    })
  }

  getUser = async () => {
    let userData = await getUserData()
    this.setState({
      user: userData,
    })
  }

  setPhotosInState = () => {
    if (this.state.currentFeed != undefined) {
      this.state.currentFeed.photos.forEach((photo) => {
        switch (photo.type) {
          case 'S':
            this.setState({ currentSideImage: photo.url })
            break
          case 'B':
            this.setState({ currentBackImage: photo.url })
            break
          case 'F':
            this.setState({ currentFrontImage: photo.url })
            break
          default:
            break
        }
      })
    }
    if (this.state.earliestFeed != undefined) {
      this.state.earliestFeed.photos.forEach((photo) => {
        switch (photo.type) {
          case 'S':
            this.setState({ earliestSideImage: photo.url })
            break
          case 'B':
            this.setState({ earliestBackImage: photo.url })
            break
          case 'F':
            this.setState({ earliestFrontImage: photo.url })
            break
          default:
            break
        }
      })
    }
  }

  onOpenMenuClick = () => {
    this.setState({
      openMenu: !this.state.openMenu,
    })
  }

  closeMenu = () => {
    this.setState({
      openMenu: false,
    })
  }

  changeLocation = (location) => {
    this.props.history.push(location)
  }

  onSubpageChange = (page) => {
    this.setState({
      actualPage: page,
    })
  }

  goBack = () => {
    this.props.history.goBack()
  }

  render() {
    return (
      <CompareScreen
        onSubpageChange={this.onSubpageChange}
        changeLocation={this.changeLocation}
        closeMenu={this.closeMenu}
        onOpenMenuClick={this.onOpenMenuClick}
        openMenu={this.state.openMenu}
        isPlayerActive={this.state.isPlayerActive}
        entry={this.state.currentFeed}
        currentEntryFrontImage={this.state.currentFrontImage}
        currentEntryBackImage={this.state.currentBackImage}
        currentEntrySideImage={this.state.currentSideImage}
        oldEntryFrontImage={this.state.earliestSideImage}
        oldEntryBackImage={this.state.earliestBackImage}
        oldEntrySideImage={this.state.earliestSideImage}
        user={this.state.user}
        goBack={this.goBack}
        currentFeed={this.state.currentFeed}
        earliestFeed={this.state.earliestFeed}
      />
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
  }
}

export default compose(
  withRouter,
  connect(mapStateToProps, null)
)(CompareScreenContainer)
